// src/styles/messenger/layout.style.ts
import { styled } from '../stitches.config';
import { NAVIGATION_HEIGHT } from '../../constants/global';
import { Button } from '../_app.style';
import * as Popover from '@radix-ui/react-popover';
import { ButtonBase } from '../search/search.style';


export const MessengerPageShell = styled('div', {

  // paddingTop: `calc(${NAVIGATION_HEIGHT})`, // Sits right below the main nav
  // minHeight: '800px',
  background: '#f0f2f5', // A neutral, light grey background
  boxSizing: 'border-box',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  height: '100%',

});


export const MessengerPageWrapper = styled('div', {
  display: 'grid',
  gridTemplateColumns: '30% 70%', 
  width: '100%',
  height: '100%',
  boxShadow: '0 6px 24px rgba(0,0,0,0.04)',

  '& > *': {
    minWidth: 0, 
    minHeight: 0,
  },

  '@media (max-width: 900px)': {
    display: 'block',
    position: 'relative',
    gridTemplateColumns: 'none',

    '&.keyboard-open': {
      maxHeight: '60%',
    }
  },

  variants: {
    mobileView: {
      list: {
        '@media (max-width: 900px)': {
          // Show List, Hide Chat
          '& > :nth-child(1)': { display: 'flex' },
          '& > :nth-child(2)': { display: 'none' },
        },
      },
      chat: {
        '@media (max-width: 900px)': {
          // Hide List, Show Chat
          '& > :nth-child(1)': { display: 'none' },
          '& > :nth-child(2)': { display: 'flex' },
        },
      },
    },
  },

});
// This component will wrap your scrollable lists
export const ScrollableContent = styled('div', {
    flex: '1 1 auto',     // <-- key
    minHeight: 0,         // <-- key in flex/grid containers
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '0.5rem',

  });

  export const PopoverContent = styled(Popover.Content, {
    borderRadius: '16px',
    padding: '1rem',
    width: 'max-content', // Make it as wide as the schedule grid
    maxWidth: '80vw', // Don't let it get too wide on large screens
    backgroundColor: 'white',
    boxShadow: '0 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
    zIndex: 100, // Ensure it appears on top
});

export const PopoverArrow = styled(Popover.Arrow, {
    fill: 'white',
});
  
export const NoResultsMessage = styled('div', {
  position: 'absolute',
  width: '100%',
  inset: 0, // Covers the entire parent
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
  color: '$lowContrast',

  '> h2': {
    margin: 0,
    marginBottom: '0.5rem',
  },
});


export const NameAndTagsContainer = styled('div', {
  display: 'flex',
  alignItems: 'baseline', // This aligns the text itself
  gap: '0.75rem',
});

export const Overlay = styled('div', {
  position: 'absolute',
  width: '100%',
  inset: 0, // Covers the entire parent
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});


// ... (Imports and Shell/Wrapper remain the same)

// 3. LIST AREA
export const ConversationListArea = styled('aside', {
  display: 'flex',
  flexDirection: 'column',
  
  // ✅ DESKTOP SIZING:
  // Use 'auto' width so margins don't cause overflow
  width: 'auto', 
  height: 'calc(100% - 2rem)', 

  // ✅ DESKTOP MARGINS (The Split):
  // 1rem Top | 0.5rem Right (Inner Gutter) | 1rem Bottom | 1rem Left
  margin: '1rem 0.5rem 1rem 1rem', 
  
  // Styling
  background: 'white',
  // borderRight: '1px solid $gray6', // ❌ REMOVE THIS (It's a standalone card now)
  
  // Grid Internals
  minHeight: 0,
  gridTemplateRows: 'auto 1fr', 
  overflow: 'hidden',
  
  // Corners (Rounded on ALL sides now)
  borderRadius: '16px',

  // ✅ MOBILE TWEAKS:
  '@media (max-width: 900px)': { 
    // On mobile, it stands alone, so give it even margins
    margin: '1rem', 
    width: 'auto',
  }, 
});

// 4. CHAT AREA
export const ChatArea = styled('section', {
  display: 'flex',
  flexDirection: 'column',
  
  // ✅ DESKTOP SIZING:
  width: 'auto',
  height: 'calc(100% - 2rem)', 
  
  // ✅ DESKTOP MARGINS (The Split):
  // 1rem Top | 1rem Right | 1rem Bottom | 0.5rem Left (Inner Gutter)
  margin: '1rem 1rem 1rem 0.5rem', 
  
  // Styling
  background: 'white',
  
  // Grid Internals
  minHeight: 0,
  overflow: 'hidden', 
  position: 'relative',
  gridTemplateRows: 'auto 1fr auto',
  
  // Corners
  borderRadius: '16px',

  // ✅ MOBILE TWEAKS:
  '@media (max-width: 900px)': { 
    // Restore full margins on mobile
    margin: '1rem', 
    width: 'auto', 
  }, 
});

  
  // No changes are needed for ConversationListHeader
  export const ConversationListHeader = styled('div', {

  
    // --- Existing Styles ---
    height: '3.5rem',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: '1px solid $elementBorder',
    background: '$blueWeeks',
    fontSize: '$md',
    fontWeight: 600,
    color: '$sand12',
  });

  export const ConversationListHeader2 = styled('div', {

  
    // --- Existing Styles ---
    height: '3.5rem',
    // padding: '1rem',
    paddingRight: '0.75rem',
    // display: 'flex',
    display: 'grid', 
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    // justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: '1px solid $elementBorder',
    background: '$blueWeeks',
    fontSize: '$md',
    fontWeight: 600,
    color: '$sand12',
  });


  export const HeaderIconButton = styled(Button, {
    all: 'unset', // Removes default button styles
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    color: '$sand11', // A neutral grey for the icon
    transition: 'background-color 0.2s ease, color 0.2s ease',
      // --- 2. Remove the color change from the hover state ---
      '&:not([data-active="true"]):hover': {
        backgroundColor: '$blueHover',
        // The 'color' property is removed, so it stays black

  '& svg': {
        fill: 'var(--colors-blue11)',
        // stroke: 'var(--colors-blue11)',
      },  
      },
  });


  export const HeaderIconStrokeButton = styled(Button, {
    all: 'unset', // Removes default button styles
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    color: '$sand11', // A neutral grey for the icon
    transition: 'background-color 0.2s ease, color 0.2s ease',
      // --- 2. Remove the color change from the hover state ---
     '&:hover': {
    backgroundColor: '$blueHover',
    '& svg': {
      stroke: 'var(--colors-blue11)',
    },  
  },

  // Style for the moment the button is pressed
  '&:active': {
    backgroundColor: '$blueHover',
    '& svg': {
      stroke: 'var(--colors-blue11)',
    },  
  },

  "&[data-state='open']": {
    backgroundColor: '$blueHover', // Or any other "active" color
    '& svg': {
      stroke: 'var(--colors-blue11)',
    },
  },
  });


  // in src/styles/messenger/layout.style.ts

export const ChatHeaderProfile = styled('div', {
  display: 'flex',
  alignItems: 'center',
  // gap: '0.75rem',
  padding: '0 0.5rem',
});

export const HideOnMobileText = styled('span', {
  display: 'inline', 
  '@media (max-width: 600px)': {
    display: 'none',
  },
});

export const MobileBackButton = styled(ButtonBase, {
  // 1. Visual Styles (Exactly like your SecondaryButton)
  background: 'transparent',
  padding: '0rem', // Slight adjustment for an icon button
  // color: '$sand12', 
  color: '$sand11', // A neutral grey for the icon
  transition: 'background-color 0.2s ease, color 0.2s ease',
    // --- 2. Remove the color change from the hover state ---
   '&:hover': {
  backgroundColor: '$blueHover',
  '& svg': {
    stroke: 'var(--colors-blue11)',
  },  
},


  // 2. Responsive Logic (The Breakpoint)
  display: 'none', // Hidden on Desktop
  
  '@media (max-width: 900px)': {
    display: 'flex', // Visible on Mobile
    alignItems: 'center',
    justifyContent: 'center',
  },

  // 3. Variants
  variants: {
    normal: {
      true: {
        border: '1px solid $sand12',
      },
      false: {
        border: 'none'
      }
    },
  },

  defaultVariants: {
    normal: 'false', // Default to no border for the icon, change to 'true' if you want the box
  },
});